/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Try_EyebrowInputs */

const en_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try it`)
};

const zh_hans1_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试一试`)
};

const pt_br2_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste`)
};

const es_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruébalo`)
};

const fr_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayer`)
};

const de_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausprobieren`)
};

const ru_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать`)
};

const it_endpoint_try_eyebrow = /** @type {(inputs: Endpoint_Try_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provalo`)
};

/**
* | output |
* | --- |
* | "Try it" |
*
* @param {Endpoint_Try_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_try_eyebrow = /** @type {((inputs?: Endpoint_Try_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Try_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_try_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_try_eyebrow(inputs)
	if (locale === "es") return es_endpoint_try_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_try_eyebrow(inputs)
	if (locale === "de") return de_endpoint_try_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_try_eyebrow(inputs)
	if (locale === "it") return it_endpoint_try_eyebrow(inputs)
	return en_endpoint_try_eyebrow(inputs)
});